export const educationData = [
    {
        id: 1,
        institution: 'University of London',
        course: 'BSc Computer Science',
        startYear: '2020',
        endYear: '2025'
    },
    {
        id: 2,
        institution: 'Universidad Nacional Autónoma de México',
        course: 'BSc Psychology',
        startYear: '2013',
        endYear: '2017'
    },
]